const instructionsDataInitial = [
  {
    id: "pancetta",
    name: "Pancetta",
    steps: [
      { text: "Heat the #olive oil# in a large skillet over medium heat" },
      { text: "Add the #pancetta# and cook until rendered and crispy, about 5 to 7 minutes" },
      { text: "Using a slotted spoon, transfer the pancetta to a small bowl and set aside, leaving any rendered fat behind in the skillet" }
    ]
  },
  {
    id: "sauce",
    name: "Sauce",
    steps: [
      { text: "Add the #onion#, #red pepper flakes#, and a generous pinch of *salt* to the pan and cook over medium-low heat. Stir often, until the onions are soft, translucent, and just beginning to gain color, about 5 to 7 minutes." },
      { text: "Add the #garlic# and cook until fragrant, stirring constantly, about 1 to 2 minutes" },
      { text: "Add the #tomato paste# and cook, stirring constantly to prevent scorching, until the tomato paste has started to cook slightly and darken in color" },
      { text: "Add the #canned tomatoes# and reserved *crispy pancetta* back into the skillet and stir the sauce until all of the ingredients are incorporated evenly" },
      { text: "Bring the sauce to a simmer and cook for an additional 15 to 20 minutes, seasoning to taste with salt and black pepper" }
    ]
  },
  {
    id: "pasta",
    name: "Cook rigatoni & combine",
    steps: [
      { text: "Meanwhile, boil the #rigatoni# until just shy of al dente" },
      { text: "Using a spider skimmer or large slotted spoon, transfer the pasta directly into the skillet and toss with the sauce" },
      { text: "With the skillet over low heat, add the #pecorino cheese# and a generous splash or two of starchy *pasta water* as needed to help loosen the sauce. Toss until the sauce evenly coats the pasta." },
      { text: "Serve with additional finely grated *pecorino* as desired" }
    ]
  }
]

function importAll(r) {
  return r.keys().map(r);
}

// this is a different approach where we only import media from the top level
// folder (media/instructions), which is done by setting 'false' instead of 'true'
// since the file name already has the sectionId in it, we don't need to put the files
// into separate folders
const allMedia = importAll(require.context('./media/instructions', false, /\.(png|jpe?g|gif|webp|mp4|mov|avi|webm|mkv|flv|wmv|m4v|mpeg|mpg|svg)$/));
  
const mediaBySection = allMedia.reduce((acc, path) => {
  const sectionId = path.split('_')[0].split('/').pop(); // Extract section id from path
  if (!acc[sectionId]) { acc[sectionId] = [] } // Initialize array if it doesn't exist
  acc[sectionId].push(path); // Add path to array
  return acc;
}, {});

export const instructions = instructionsDataInitial.map(section => {
  // if there's an array of media for the given section
  if (mediaBySection[section.id]) {
      // add media array
      return { ...section, media: mediaBySection[section.id] };
  } else {
      return section;
  }
})